const apiKey = {
  key: '158307fe2b19d9a6d20625f3c739040d',
  secret: '3af4ebfaef6afc1a'
}

export default apiKey;
